export interface ErrorMessages {
  [key: string]: string;
}
